export default __webpack_public_path__ + "static/buying-property-img-d-da4eff5ec961383e701522cdc6ed6b85.jpg";